import { render, staticRenderFns } from "./MainDetailForReview.vue?vue&type=template&id=764752ea&scoped=true&"
import script from "./MainDetailForReview.vue?vue&type=script&lang=js&"
export * from "./MainDetailForReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764752ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764752ea')) {
      api.createRecord('764752ea', component.options)
    } else {
      api.reload('764752ea', component.options)
    }
    module.hot.accept("./MainDetailForReview.vue?vue&type=template&id=764752ea&scoped=true&", function () {
      api.rerender('764752ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/MainDetailForReview.vue"
export default component.exports